"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-nazzaro-val-cavargna": {
    "0c4ac39d": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "skipSearch": false
    }],
    "bubegno": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c724e3ab": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "skipSearch": false
    }],
    "burena": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e6010ff1": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "skipSearch": false
    }],
    "carde": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec6c6cc2": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "skipSearch": false
    }],
    "crevegno": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5182ce25": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "skipSearch": false
    }],
    "forni-vecchi": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a860b99b": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "skipSearch": false
    }],
    "revole": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08462943": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "skipSearch": false
    }],
    "rugino": [{
      "hkey": "42027592",
      "slug": "san-nazzaro-val-cavargna",
      "name": "San Nazzaro Val Cavargna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;